/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AuctionDataDto } from '../../models/auction-data-dto';
import { AuctionDto } from '../../models/auction-dto';

export interface CreateAuction$Params {
  'X-API-Version'?: string;
      body: AuctionDataDto
}

export function createAuction(http: HttpClient, rootUrl: string, params: CreateAuction$Params, context?: HttpContext): Observable<StrictHttpResponse<AuctionDto>> {
  const rb = new RequestBuilder(rootUrl, createAuction.PATH, 'post');
  if (params) {
    rb.header('X-API-Version', params['X-API-Version'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AuctionDto>;
    })
  );
}

createAuction.PATH = '/api/auctions';
